export const COUNTRY_REGIONS = {
    Australia: {
        code: "AU",
        regions: {
            "New South Wales": {
                code: "NSW",
                cities: ["Sydney"],
            },
            Victoria: {
                code: "VIC",
                cities: ["Melbourne", "Daylesford"],
            },
        },
    },
};

// Kept for callers that still consume the original country -> cities shape.
export const COUNTRY_CITIES = Object.fromEntries(
    Object.entries(COUNTRY_REGIONS).map(([country, config]) => [
        country,
        Object.values(config.regions).flatMap((region) => region.cities),
    ])
);

export const getCountries = () => Object.keys(COUNTRY_REGIONS);

export const getCountryCode = (country) =>
    COUNTRY_REGIONS[country]?.code || "";

export const getRegions = (country) =>
    Object.entries(COUNTRY_REGIONS[country]?.regions || {}).map(
        ([name, config]) => ({
            name,
            code: config.code,
        })
    );

export const getCities = (country, region) => {
    if (region) {
        return COUNTRY_REGIONS[country]?.regions?.[region]?.cities || [];
    }

    return COUNTRY_CITIES[country] || [];
};
